import React, { useState } from "react";
import { motion } from "framer-motion";
import styles from "./RightSideGrid.module.css";
import { useNavigate } from "react-router-dom";

const RightSideGrid = ({
  tiles = [
    {
      id: "topRight",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
        >
          <path
            d="M4.5 39.5C4.5 39.8978 4.65804 40.2794 4.93934 40.5607C5.22064 40.842 5.60218 41 6 41H42C42.3978 41 42.7794 40.842 43.0607 40.5607C43.342 40.2794 43.5 39.8978 43.5 39.5C43.5 39.1022 43.342 38.7206 43.0607 38.4393C42.7794 38.158 42.3978 38 42 38H40.5V26C40.5 25.6022 40.342 25.2206 40.0607 24.9393C39.7794 24.658 39.3978 24.5 39 24.5H34.5C34.1022 24.5 33.7206 24.658 33.4393 24.9393C33.158 25.2206 33 25.6022 33 26V38H30V17C30 16.6022 29.842 16.2206 29.5607 15.9393C29.2794 15.658 28.8978 15.5 28.5 15.5H22.5C22.1022 15.5 21.7206 15.658 21.4393 15.9393C21.158 16.2206 21 16.6022 21 17V38H18V8C18 7.60218 17.842 7.22064 17.5607 6.93934C17.2794 6.65804 16.8978 6.5 16.5 6.5H9C8.60218 6.5 8.22064 6.65804 7.93934 6.93934C7.65804 7.22064 7.5 7.60218 7.5 8V38H6C5.60218 38 5.22064 38.158 4.93934 38.4393C4.65804 38.7206 4.5 39.1022 4.5 39.5Z"
            fill="white"
          />
        </svg>
      ), // Can be a React component or string
      title: "OR Loss Tree",
      subtitle:
        "A comprehensive loss tree analysis providing valuable insights into Level 1 and Level 2 root causes across the supply chain",
    },
    {
      id: "topLeft",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
        >
          <path
            d="M39 6.72754H34.5V5.22754C34.5 4.82971 34.342 4.44818 34.0607 4.16688C33.7794 3.88557 33.3978 3.72754 33 3.72754C32.6022 3.72754 32.2206 3.88557 31.9393 4.16688C31.658 4.44818 31.5 4.82971 31.5 5.22754V6.72754H16.5V5.22754C16.5 4.82971 16.342 4.44818 16.0607 4.16688C15.7794 3.88557 15.3978 3.72754 15 3.72754C14.6022 3.72754 14.2206 3.88557 13.9393 4.16688C13.658 4.44818 13.5 4.82971 13.5 5.22754V6.72754H9C8.20435 6.72754 7.44129 7.04361 6.87868 7.60622C6.31607 8.16883 6 8.93189 6 9.72754V39.7275C6 40.5232 6.31607 41.2863 6.87868 41.8489C7.44129 42.4115 8.20435 42.7275 9 42.7275H39C39.7957 42.7275 40.5587 42.4115 41.1213 41.8489C41.6839 41.2863 42 40.5232 42 39.7275V9.72754C42 8.93189 41.6839 8.16883 41.1213 7.60622C40.5587 7.04361 39.7957 6.72754 39 6.72754ZM15.75 35.2275C15.305 35.2275 14.87 35.0956 14.5 34.8483C14.13 34.6011 13.8416 34.2497 13.6713 33.8386C13.501 33.4274 13.4564 32.975 13.5432 32.5386C13.63 32.1021 13.8443 31.7012 14.159 31.3866C14.4737 31.0719 14.8746 30.8576 15.311 30.7708C15.7475 30.684 16.1999 30.7285 16.611 30.8988C17.0222 31.0691 17.3736 31.3575 17.6208 31.7275C17.868 32.0975 18 32.5325 18 32.9775C18 33.5743 17.7629 34.1466 17.341 34.5685C16.919 34.9905 16.3467 35.2275 15.75 35.2275ZM24 35.2275C23.555 35.2275 23.12 35.0956 22.75 34.8483C22.38 34.6011 22.0916 34.2497 21.9213 33.8386C21.751 33.4274 21.7064 32.975 21.7932 32.5386C21.88 32.1021 22.0943 31.7012 22.409 31.3866C22.7237 31.0719 23.1246 30.8576 23.561 30.7708C23.9975 30.684 24.4499 30.7285 24.861 30.8988C25.2722 31.0691 25.6236 31.3575 25.8708 31.7275C26.118 32.0975 26.25 32.5325 26.25 32.9775C26.25 33.5743 26.0129 34.1466 25.591 34.5685C25.169 34.9905 24.5967 35.2275 24 35.2275ZM24 27.7275C23.555 27.7275 23.12 27.5956 22.75 27.3483C22.38 27.1011 22.0916 26.7497 21.9213 26.3386C21.751 25.9274 21.7064 25.475 21.7932 25.0386C21.88 24.6021 22.0943 24.2012 22.409 23.8865C22.7237 23.5719 23.1246 23.3576 23.561 23.2708C23.9975 23.184 24.4499 23.2285 24.861 23.3988C25.2722 23.5691 25.6236 23.8575 25.8708 24.2275C26.118 24.5975 26.25 25.0325 26.25 25.4775C26.25 26.0743 26.0129 26.6466 25.591 27.0685C25.169 27.4905 24.5967 27.7275 24 27.7275ZM32.25 35.2275C31.805 35.2275 31.37 35.0956 31 34.8483C30.63 34.6011 30.3416 34.2497 30.1713 33.8386C30.001 33.4274 29.9564 32.975 30.0432 32.5386C30.13 32.1021 30.3443 31.7012 30.659 31.3866C30.9737 31.0719 31.3746 30.8576 31.811 30.7708C32.2475 30.684 32.6999 30.7285 33.111 30.8988C33.5222 31.0691 33.8736 31.3575 34.1208 31.7275C34.368 32.0975 34.5 32.5325 34.5 32.9775C34.5 33.5743 34.2629 34.1466 33.841 34.5685C33.419 34.9905 32.8467 35.2275 32.25 35.2275ZM32.25 27.7275C31.805 27.7275 31.37 27.5956 31 27.3483C30.63 27.1011 30.3416 26.7497 30.1713 26.3386C30.001 25.9274 29.9564 25.475 30.0432 25.0386C30.13 24.6021 30.3443 24.2012 30.659 23.8865C30.9737 23.5719 31.3746 23.3576 31.811 23.2708C32.2475 23.184 32.6999 23.2285 33.111 23.3988C33.5222 23.5691 33.8736 23.8575 34.1208 24.2275C34.368 24.5975 34.5 25.0325 34.5 25.4775C34.5 26.0743 34.2629 26.6466 33.841 27.0685C33.419 27.4905 32.8467 27.7275 32.25 27.7275ZM39 15.7275H9V9.72754H13.5V11.2275C13.5 11.6254 13.658 12.0069 13.9393 12.2882C14.2206 12.5695 14.6022 12.7275 15 12.7275C15.3978 12.7275 15.7794 12.5695 16.0607 12.2882C16.342 12.0069 16.5 11.6254 16.5 11.2275V9.72754H31.5V11.2275C31.5 11.6254 31.658 12.0069 31.9393 12.2882C32.2206 12.5695 32.6022 12.7275 33 12.7275C33.3978 12.7275 33.7794 12.5695 34.0607 12.2882C34.342 12.0069 34.5 11.6254 34.5 11.2275V9.72754H39V15.7275Z"
            fill="white"
          />
        </svg>
      ),
      title: "Daily Production Scheduling",
      subtitle:
        "A Smart Scheduler generating daily schedule basis Changeover matrix, Service prioritization and RMPM Availability",
    },
    {
      id: "bottomLeft",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
        >
          <g clipPath="url(#clip0_1242_10250)">
            <path
              d="M39.9278 27.259L44.05 22.5016L39.9278 17.7442L37.9618 19.4482L39.4781 21.1986H32.3559C32.3559 21.1986 32.3559 21.2056 32.3559 21.2102C32.1194 19.2975 31.359 17.5448 30.2276 16.0958C30.2345 16.1027 30.2415 16.112 30.2461 16.1189L35.2864 11.0787L35.451 13.3902L38.0476 13.2047L37.6002 6.92641L31.3219 6.47664L31.1364 9.07327L33.4479 9.23788L28.4076 14.2781C28.4076 14.2781 28.4215 14.2897 28.4308 14.2967C26.9841 13.1653 25.2314 12.4072 23.3187 12.1684C23.321 12.1684 23.3256 12.1684 23.328 12.1684V5.04617L25.0784 6.56242L26.7824 4.5964L22.025 0.476562L17.2676 4.59872L18.9716 6.56474L20.722 5.04849V12.1707C20.722 12.1707 20.7452 12.1684 20.7545 12.166C18.8372 12.4002 17.0729 13.1606 15.6192 14.2967C15.6262 14.2897 15.6354 14.2851 15.6424 14.2781L10.6021 9.23788L12.9136 9.07327L12.7281 6.47664L6.44985 6.92641L6.00239 13.2047L8.59902 13.3902L8.76363 11.0787L13.8039 16.1189C12.6841 17.5564 11.9329 19.2975 11.6941 21.1986H4.57193L6.08817 19.4482L4.12215 17.7442L0 22.5016L4.12215 27.259L6.08817 25.5549L4.57193 23.8045H11.6941C11.6941 23.8045 11.6941 23.7976 11.6941 23.7952C11.9329 25.7056 12.691 27.4583 13.8224 28.905C13.8178 28.8981 13.8108 28.8911 13.8039 28.8819L8.76363 33.9221L8.59902 31.6106L6.00239 31.7961L6.44985 38.0744L12.7281 38.5242L12.9136 35.9275L10.6021 35.7629L15.6424 30.7227C15.6424 30.7227 15.6262 30.7088 15.6192 30.7041C17.0659 31.8378 18.8209 32.596 20.7336 32.8324C20.729 32.8324 20.7267 32.8324 20.722 32.8324V39.9546L18.9716 38.4384L17.2676 40.4044L22.025 44.5266L26.7824 40.4044L25.0784 38.4384L23.328 39.9546V32.8324C23.328 32.8324 23.3187 32.8324 23.314 32.8324C25.2244 32.596 26.9771 31.8378 28.4262 30.7065C28.4215 30.7111 28.4146 30.7157 28.4076 30.7204L33.4479 35.7606L31.1364 35.9252L31.3219 38.5219L37.6002 38.0744L38.0476 31.7961L35.451 31.6106L35.2864 33.9221L30.2461 28.8819C30.2461 28.8819 30.2392 28.8888 30.2368 28.8934C31.3613 27.4514 32.1171 25.7079 32.3559 23.8022H39.4781L37.9618 25.5526L39.9278 27.2566V27.259ZM22.025 27.7945C19.1548 27.7945 16.8201 25.4599 16.8201 22.5897C16.8201 19.7195 19.1548 17.3848 22.025 17.3848C24.8952 17.3848 27.2299 19.7195 27.2299 22.5897C27.2299 25.4599 24.8952 27.7945 22.025 27.7945Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1242_10250">
              <rect
                width="44.05"
                height="44.05"
                fill="white"
                transform="translate(0 0.476562)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      title: "Agile OR",
      subtitle:
        "An Autonomous Engine providing day to day alerts, visibility, and recommendations to mitigate the risks for manufacturing disruptions",
    },
    {
      id: "bottomRight",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            d="M25.5 22.5H30L30 25.5H25.5L25.5 22.5ZM45 12L45 37.5C45 37.8978 44.842 38.2794 44.5607 38.5607C44.2794 38.842 43.8978 39 43.5 39H9C7.4087 39 5.88258 38.3679 4.75736 37.2426C3.63214 36.1174 3 34.5913 3 33L3 12C3 10.4087 3.63214 8.88258 4.75736 7.75736C5.88258 6.63214 7.4087 6 9 6H12C12.3978 6 12.7794 6.15804 13.0607 6.43934C13.342 6.72064 13.5 7.10218 13.5 7.5L13.5 10.5H43.5C43.8978 10.5 44.2794 10.658 44.5607 10.9393C44.842 11.2206 45 11.6022 45 12ZM10.5 9H9C8.20435 9 7.44129 9.31607 6.87868 9.87868C6.31607 10.4413 6 11.2044 6 12L6 27.8044C6.91145 27.2761 7.94652 26.9986 9 27H10.5L10.5 9ZM33 25.5L33 22.5H36C36.3978 22.5 36.7794 22.342 37.0607 22.0607C37.342 21.7794 37.5 21.3978 37.5 21C37.5 20.6022 37.342 20.2206 37.0607 19.9393C36.7794 19.658 36.3978 19.5 36 19.5H33L33 18C33 17.6022 32.842 17.2206 32.5607 16.9393C32.2794 16.658 31.8978 16.5 31.5 16.5C31.1022 16.5 30.7206 16.658 30.4393 16.9393C30.158 17.2206 30 17.6022 30 18L30 19.5H25.5L25.5 18C25.5 17.6022 25.342 17.2206 25.0607 16.9393C24.7794 16.658 24.3978 16.5 24 16.5C23.6022 16.5 23.2206 16.658 22.9393 16.9393C22.658 17.2206 22.5 17.6022 22.5 18L22.5 19.5H19.5C19.1022 19.5 18.7206 19.658 18.4393 19.9393C18.158 20.2206 18 20.6022 18 21C18 21.3978 18.158 21.7794 18.4393 22.0607C18.7206 22.342 19.1022 22.5 19.5 22.5H22.5L22.5 25.5H19.5C19.1022 25.5 18.7206 25.658 18.4393 25.9393C18.158 26.2206 18 26.6022 18 27C18 27.3978 18.158 27.7794 18.4393 28.0607C18.7206 28.342 19.1022 28.5 19.5 28.5H22.5L22.5 30C22.5 30.3978 22.658 30.7794 22.9393 31.0607C23.2206 31.342 23.6022 31.5 24 31.5C24.3978 31.5 24.7794 31.342 25.0607 31.0607C25.342 30.7794 25.5 30.3978 25.5 30L25.5 28.5H30L30 30C30 30.3978 30.158 30.7794 30.4393 31.0607C30.7206 31.342 31.1022 31.5 31.5 31.5C31.8978 31.5 32.2794 31.342 32.5607 31.0607C32.842 30.7794 33 30.3978 33 30L33 28.5H36C36.3978 28.5 36.7794 28.342 37.0607 28.0607C37.342 27.7794 37.5 27.3978 37.5 27C37.5 26.6022 37.342 26.2206 37.0607 25.9393C36.7794 25.658 36.3978 25.5 36 25.5H33Z"
            fill="white"
          />
        </svg>
      ),
      title: "Long Term Capacity Planning",
      subtitle:
        "An automated DSR solution that provides monthly alerts & recommendations to planners on Capacity Utilization (CU%)",
    },
  ],
}) => {
  const [hoveredTile, setHoveredTile] = useState(null);

  const getTileById = (id) => tiles.find((tile) => tile.id === id);

  // Get data for each tile
  const topRightTile = getTileById("topRight");
  const topLeftTile = getTileById("topLeft");
  const bottomRightTile = getTileById("bottomRight");
  const bottomLeftTile = getTileById("bottomLeft");


  const navigate = useNavigate();

  // const handleGridClick = (id) => {
  //   const routeMap = {
  //     topLeft: "/samarth/smart_production_scheduler",
  //     topRight: "/samarth/weekly_or",
  //     bottomLeft: "/samarth/agile_or",
  //     bottomRight: "/ltcp/landing",
  //   };
  //   const route = routeMap[id];
  //   if (route) {
  //     navigate(route);
  //   }
  // };
  const handleGridClick = (id) => {
    const tile = tiles.find((t) => t.id === id);
    if (tile?.route) {
      navigate(tile.route);
    }
  };

  return (
    <div className={styles.container}>
      <svg viewBox="0 0 645 781" className={styles.svg}>
        <defs>
          <clipPath id="bgblur_0_clip_path">
            <path d="M355 379H634C639.523 379 644 374.523 644 369V13.1203C644 6.51808 637.72 1.72234 631.35 3.45711C603.057 11.162 533.32 29.9996 484.5 41.8975C433.973 54.2113 373.203 70.2822 352.401 75.8195C348.028 76.9835 345 80.941 345 85.4661V369C345 374.523 349.477 379 355 379Z" />
          </clipPath>
          <clipPath id="bgblur_1_clip_path">
            <path d="M321 369V92.3832C321 86.0124 315.145 81.2563 308.913 82.5777C280.993 88.4972 210.649 103.209 161.5 111.75C110.582 120.598 35.8163 130.919 10.637 134.336C5.66953 135.01 2 139.244 2 144.257V369C2 374.523 6.47717 379 12 379H311C316.523 379 321 374.523 321 369Z" />
          </clipPath>
          <clipPath id="bgblur_2_clip_path">
            <path d="M644 767.336V413C644 407.477 639.523 403 634 403H354C348.477 403 344 407.477 344 413V694.762C344 699.318 347.08 703.298 351.491 704.442L631.491 777.016C637.823 778.658 644 773.878 644 767.336Z" />
          </clipPath>
          <clipPath id="bgblur_3_clip_path">
            <path d="M320 688.488V413C320 407.477 315.523 403 310 403H11C5.47714 403 1 407.477 1 413V636.739C1 641.753 4.67194 645.989 9.64124 646.661C34.8246 650.068 109.584 660.357 160.5 669.183C209.651 677.703 279.999 692.387 307.917 698.294C314.148 699.613 320 694.857 320 688.488Z" />
          </clipPath>

          <linearGradient
            id="paint0_linear"
            x1="494.5"
            y1="379"
            x2="494.5"
            y2="50"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00B2FF" />
            <stop offset="1" stopColor="#005EEF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="161.5"
            y1="379"
            x2="161.5"
            y2="130"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00B2FF" />
            <stop offset="1" stopColor="#005EEF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="494"
            y1="730.259"
            x2="494"
            y2="403"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00B2FF" />
            <stop offset="1" stopColor="#005EEF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="494"
            y1="544.06"
            x2="494"
            y2="730.259"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint4_linear"
            x1="160.5"
            y1="650.866"
            x2="160.5"
            y2="403"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00B2FF" />
            <stop offset="1" stopColor="#005EEF" />
          </linearGradient>
          <linearGradient
            id="paint5_linear"
            x1="160.5"
            y1="509.839"
            x2="160.5"
            y2="650.866"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>

          <linearGradient
            id="hover_gradient"
            x1="150.5"
            y1="379"
            x2="150.5"
            y2="50"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.1679" stopColor="rgba(0, 178, 255, 0.90)" />
            <stop offset="1" stopColor="rgba(0, 94, 239, 0.90)" />
          </linearGradient>
        </defs>

        {/* Top right panel with content */}
        <foreignObject x="264" y="-77.901" width="461" height="537.901">
          <div
            style={{
              backdropFilter: "blur(40px)",
              clipPath: "url(#bgblur_0_clip_path)",
              height: "100%",
              width: "100%",
            }}
          />
        </foreignObject>
        <motion.path
          d="M355 379H634C639.523 379 644 374.523 644 369V13.1203C644 6.51808 637.72 1.72234 631.35 3.45711C603.057 11.162 533.32 29.9996 484.5 41.8975C433.973 54.2113 373.203 70.2822 352.401 75.8195C348.028 76.9835 345 80.941 345 85.4661V369C345 374.523 349.477 379 355 379Z"
          fill="url(#paint0_linear)"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth={hoveredTile === "topRight" ? "2" : "2"}
          onMouseEnter={() => setHoveredTile("topRight")}
          onMouseLeave={() => setHoveredTile(null)}
          onClick={() => handleGridClick("topRight")}
          className={styles.tile}
          animate={{
            fill:
              hoveredTile === "topRight"
                ? "url(#hover_gradient)"
                : "url(#paint0_linear)",
            stroke:
              hoveredTile === "topRight" ? "#FFF" : "rgba(255, 255, 255, 0.25)",
            strokeWidth: hoveredTile === "topRight" ? 2 : 2,
            filter:
              hoveredTile === "topRight"
                ? "drop-shadow(0px 4px 12px rgba(1, 137, 247, 0.25))"
                : "none",
          }}
          transition={{ duration: 0.3 }}
        />

        {/* Content for top right tile */}
        <foreignObject
          x="370"
          y="100"
          width="250"
          height="300"
          onMouseEnter={() => setHoveredTile("topRight")}
          onMouseLeave={() => setHoveredTile(null)}
          onClick={() => handleGridClick("topRight")}
        >
          {hoveredTile === "topRight" && (
            <div
              style={{
                cursor: "pointer",
                position: "absolute",
                top: "-16px",
                right: "8px",
                margin: "8px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
              >
                <path
                  d="M25.0001 8.22754V21.2275C25.0001 21.4928 24.8947 21.7471 24.7072 21.9346C24.5196 22.1222 24.2653 22.2275 24.0001 22.2275C23.7349 22.2275 23.4805 22.1222 23.293 21.9346C23.1054 21.7471 23.0001 21.4928 23.0001 21.2275V10.6413L8.70757 24.935C8.51993 25.1227 8.26543 25.2281 8.00007 25.2281C7.7347 25.2281 7.48021 25.1227 7.29257 24.935C7.10493 24.7474 6.99951 24.4929 6.99951 24.2275C6.99951 23.9622 7.10493 23.7077 7.29257 23.52L21.5863 9.22754H11.0001C10.7349 9.22754 10.4805 9.12218 10.293 8.93465C10.1054 8.74711 10.0001 8.49276 10.0001 8.22754C10.0001 7.96232 10.1054 7.70797 10.293 7.52043C10.4805 7.3329 10.7349 7.22754 11.0001 7.22754H24.0001C24.2653 7.22754 24.5196 7.3329 24.7072 7.52043C24.8947 7.70797 25.0001 7.96232 25.0001 8.22754Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
          <div className={styles.tileContent}>
            <div className={styles.tileIcon}>{topRightTile?.icon}</div>
            <h3 className={styles.tileTitle}>{topRightTile.title}</h3>
            <p className={styles.tileSubtitle}>{topRightTile.subtitle}</p>
          </div>
        </foreignObject>

        <motion.path
          d="M321 369V92.3832C321 86.0124 315.145 81.2563 308.913 82.5777C280.993 88.4972 210.649 103.209 161.5 111.75C110.582 120.598 35.8163 130.919 10.637 134.336C5.66953 135.01 2 139.244 2 144.257V369C2 374.523 6.47717 379 12 379H311C316.523 379 321 374.523 321 369Z"
          fill="url(#paint1_linear)"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth={hoveredTile === "topLeft" ? "2" : "2"}
          onMouseEnter={() => setHoveredTile("topLeft")}
          onMouseLeave={() => setHoveredTile(null)}
          onClick={() => handleGridClick("topLeft")}
          style={{ cursor: "pointer" }}
          animate={{
            fill:
              hoveredTile === "topLeft"
                ? "url(#hover_gradient)"
                : "url(#paint1_linear)",
            stroke:
              hoveredTile === "topLeft" ? "#FFF" : "rgba(255, 255, 255, 0.25)",
            strokeWidth: hoveredTile === "topLeft" ? 2 : 2,
            filter:
              hoveredTile === "topLeft"
                ? "drop-shadow(0px 4px 12px rgba(1, 137, 247, 0.25))"
                : "none",
          }}
          transition={{ duration: 0.3 }}
        />
        {/* Content for top left tile */}
        <foreignObject
          x="20"
          y="140"
          width="280"
          height="250"
          style={{ pointerEvents: "all" }}
          onMouseEnter={() => setHoveredTile("topLeft")}
          onMouseLeave={() => setHoveredTile(null)}
          onClick={() => handleGridClick("topLeft")}
        >
          {hoveredTile === "topLeft" && (
            <div
              style={{
                pointerEvents: "all",
                position: "absolute",
                top: "-16px",
                right: "-16px",
                margin: "8px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
              >
                <path
                  d="M25.0001 8.22754V21.2275C25.0001 21.4928 24.8947 21.7471 24.7072 21.9346C24.5196 22.1222 24.2653 22.2275 24.0001 22.2275C23.7349 22.2275 23.4805 22.1222 23.293 21.9346C23.1054 21.7471 23.0001 21.4928 23.0001 21.2275V10.6413L8.70757 24.935C8.51993 25.1227 8.26543 25.2281 8.00007 25.2281C7.7347 25.2281 7.48021 25.1227 7.29257 24.935C7.10493 24.7474 6.99951 24.4929 6.99951 24.2275C6.99951 23.9622 7.10493 23.7077 7.29257 23.52L21.5863 9.22754H11.0001C10.7349 9.22754 10.4805 9.12218 10.293 8.93465C10.1054 8.74711 10.0001 8.49276 10.0001 8.22754C10.0001 7.96232 10.1054 7.70797 10.293 7.52043C10.4805 7.3329 10.7349 7.22754 11.0001 7.22754H24.0001C24.2653 7.22754 24.5196 7.3329 24.7072 7.52043C24.8947 7.70797 25.0001 7.96232 25.0001 8.22754Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
          <div className={styles.tileContent}>
            <div className={styles.tileIcon}>{topLeftTile?.icon}</div>
            <h3 className={styles.tileTitle}>{topLeftTile.title}</h3>
            <p className={styles.tileSubtitle}>{topLeftTile.subtitle}</p>
          </div>
        </foreignObject>

        {/* Bottom right panel with content */}
        <foreignObject x="263" y="322" width="462" height="536.342">
          <div
            style={{
              backdropFilter: "blur(40px)",
              clipPath: "url(#bgblur_2_clip_path)",
              height: "100%",
              width: "100%",
            }}
          />
        </foreignObject>
        <motion.path
          d="M644 767.336V413C644 407.477 639.523 403 634 403H354C348.477 403 344 407.477 344 413V694.762C344 699.318 347.08 703.298 351.491 704.442L631.491 777.016C637.823 778.658 644 773.878 644 767.336Z"
          fill="url(#paint2_linear)"
          stroke="url(#paint3_linear)"
          strokeOpacity="0.4"
          strokeWidth="2"
          onMouseEnter={() => setHoveredTile("bottomRight")}
          onMouseLeave={() => setHoveredTile(null)}
          onClick={() => handleGridClick("bottomRight")}
          style={{ cursor: "pointer" }}
          animate={{
            fill:
              hoveredTile === "bottomRight"
                ? "url(#hover_gradient)"
                : "url(#paint2_linear)",
            stroke:
              hoveredTile === "bottomRight"
                ? "#FFF"
                : "rgba(255, 255, 255, 0.25)",
            strokeWidth: hoveredTile === "bottomRight" ? 2 : 2,
            filter:
              hoveredTile === "bottomRight"
                ? "drop-shadow(0px 4px 12px rgba(1, 137, 247, 0.25))"
                : "none",
          }}
          transition={{ duration: 0.3 }}
        />
        {/* Content for bottom right tile */}
        <foreignObject
          x="370"
          y="440"
          width="250"
          height="250"
          onMouseEnter={() => setHoveredTile("bottomRight")}
          onMouseLeave={() => setHoveredTile(null)}
          onClick={() => handleGridClick("bottomRight")}
        >
          {hoveredTile === "bottomRight" && (
            <div
              style={{
                pointerEvents: "auto",
                position: "absolute",
                top: "-16px",
                right: "-16px",
                margin: "8px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
              >
                <path
                  d="M25.0001 8.22754V21.2275C25.0001 21.4928 24.8947 21.7471 24.7072 21.9346C24.5196 22.1222 24.2653 22.2275 24.0001 22.2275C23.7349 22.2275 23.4805 22.1222 23.293 21.9346C23.1054 21.7471 23.0001 21.4928 23.0001 21.2275V10.6413L8.70757 24.935C8.51993 25.1227 8.26543 25.2281 8.00007 25.2281C7.7347 25.2281 7.48021 25.1227 7.29257 24.935C7.10493 24.7474 6.99951 24.4929 6.99951 24.2275C6.99951 23.9622 7.10493 23.7077 7.29257 23.52L21.5863 9.22754H11.0001C10.7349 9.22754 10.4805 9.12218 10.293 8.93465C10.1054 8.74711 10.0001 8.49276 10.0001 8.22754C10.0001 7.96232 10.1054 7.70797 10.293 7.52043C10.4805 7.3329 10.7349 7.22754 11.0001 7.22754H24.0001C24.2653 7.22754 24.5196 7.3329 24.7072 7.52043C24.8947 7.70797 25.0001 7.96232 25.0001 8.22754Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
          <div className={styles.tileContent}>
            <div className={styles.tileIcon}>{bottomRightTile?.icon}</div>
            <h3 className={styles.tileTitle}>{bottomRightTile.title}</h3>
            <p className={styles.tileSubtitle}>{bottomRightTile.subtitle}</p>
          </div>
        </foreignObject>

        <motion.path
          d="M320 688.488V413C320 407.477 315.523 403 310 403H11C5.47714 403 1 407.477 1 413V636.739C1 641.753 4.67194 645.989 9.64124 646.661C34.8246 650.068 109.584 660.357 160.5 669.183C209.651 677.703 279.999 692.387 307.917 698.294C314.148 699.613 320 694.857 320 688.488Z"
          fill="url(#paint4_linear)"
          stroke="url(#paint5_linear)"
          strokeOpacity="0.4"
          strokeWidth="2"
          onMouseEnter={() => setHoveredTile("bottomLeft")}
          onMouseLeave={() => setHoveredTile(null)}
          onClick={() => handleGridClick("bottomLeft")}
          style={{ cursor: "pointer" }}
          animate={{
            fill:
              hoveredTile === "bottomLeft"
                ? "url(#hover_gradient)"
                : "url(#paint4_linear)",
            stroke:
              hoveredTile === "bottomLeft"
                ? "#FFF"
                : "rgba(255, 255, 255, 0.25)",
            strokeWidth: hoveredTile === "bottomLeft" ? 2 : 2,
            filter:
              hoveredTile === "bottomLeft"
                ? "drop-shadow(0px 4px 12px rgba(1, 137, 247, 0.25))"
                : "none",
          }}
          transition={{ duration: 0.3 }}
        />
        {/* Content for bottom left tile */}
        <foreignObject
          x="25"
          y="430"
          width="300"
          height="300"
          onMouseEnter={() => setHoveredTile("bottomLeft")}
          onMouseLeave={() => setHoveredTile(null)}
          onClick={() => handleGridClick("bottomLeft")}
        >
          {hoveredTile === "bottomLeft" && (
            <div
              style={{
                pointerEvents: "auto",
                position: "absolute",
                top: "-16px",
                right: "16px",
                margin: "8px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
              >
                <path
                  d="M25.0001 8.22754V21.2275C25.0001 21.4928 24.8947 21.7471 24.7072 21.9346C24.5196 22.1222 24.2653 22.2275 24.0001 22.2275C23.7349 22.2275 23.4805 22.1222 23.293 21.9346C23.1054 21.7471 23.0001 21.4928 23.0001 21.2275V10.6413L8.70757 24.935C8.51993 25.1227 8.26543 25.2281 8.00007 25.2281C7.7347 25.2281 7.48021 25.1227 7.29257 24.935C7.10493 24.7474 6.99951 24.4929 6.99951 24.2275C6.99951 23.9622 7.10493 23.7077 7.29257 23.52L21.5863 9.22754H11.0001C10.7349 9.22754 10.4805 9.12218 10.293 8.93465C10.1054 8.74711 10.0001 8.49276 10.0001 8.22754C10.0001 7.96232 10.1054 7.70797 10.293 7.52043C10.4805 7.3329 10.7349 7.22754 11.0001 7.22754H24.0001C24.2653 7.22754 24.5196 7.3329 24.7072 7.52043C24.8947 7.70797 25.0001 7.96232 25.0001 8.22754Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
          <div className={styles.tileContent}>
            <div className={styles.tileIcon}>{bottomLeftTile?.icon}</div>
            <h3 className={styles.tileTitle}>{bottomLeftTile.title}</h3>
            <p className={styles.tileSubtitle}>{bottomLeftTile.subtitle}</p>
          </div>
        </foreignObject>
      </svg>
    </div>
  );
};

export default RightSideGrid;
